import { render } from "./QualitySettings.vue?vue&type=template&id=4c8e4b8b&scoped=true&ts=true"
import script from "./QualitySettings.vue?vue&type=script&lang=ts"
export * from "./QualitySettings.vue?vue&type=script&lang=ts"

import "./QualitySettings.vue?vue&type=style&index=0&id=4c8e4b8b&lang=scss&scoped=true"

import exportComponent from "/opt/pptcopilot/app/ppt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c8e4b8b"]])

export default __exports__